import {EntityService} from '../backend/interfaces/entity-service';
import {BackendApiManager} from '../managers/backend-api';

// The user-scoped API is distinct from the staff entity-services repository.
export class UserEntityServicesRepository {
  static async get(seniorId: string, entityId: string): Promise<EntityService[]> {
    const response = await BackendApiManager.instance.get<EntityService[]>(
      `/users/${encodeURIComponent(seniorId)}/entity-services?entityId=${encodeURIComponent(entityId)}`
    );
    return response.data;
  }

  static async setActive(seniorId: string, serviceId: string, active: boolean): Promise<void> {
    await BackendApiManager.instance.patch<void>(
      `/users/${encodeURIComponent(seniorId)}/entity-services/${encodeURIComponent(serviceId)}/active/${active}`
    );
  }
}
